module.exports = __webpack_public_path__ + "img/79029b0.jpg";